import React, { Component } from 'react';
import ReactGA from 'react-ga';
import './Style';

class NotFoundComponent extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        // ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div className="not-found-component">
                <div className="error-message-container">
                    <h1>Page not found</h1>
                    <h2>Unfortunately, the page you’re looking for isn’t here</h2>
                </div>
            </div>
        );
    }
}

export default NotFoundComponent;
